//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinDraw from '../../../mixins/tool/mixinDraw'
import { makeMaterial } from '../../../utils/cesiumHelpers'
import './drawIcon'
import VcIconSvg from '../../control/navigation/icon/VcIconSvg.vue'
export default {
  name: 'vc-handler-draw-polyline',
  mixins: [mixinDraw],
  components: {
    VcIconSvg
  },
  data () {
    return {
      drawType: 'polylineDrawing'
    }
  },
  props: {
    depthTest: {
      type: Boolean,
      default: false
    },
    polylineMaterial: {
      type: Object,
      default: () => {
        return {
          fabric: {
            type: 'Color',
            uniforms: {
              color: '#51ff00'
            }
          }
        }
      }
    },
    polylineWidth: {
      type: Number,
      default: 2
    },
    clampToGround: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    primitivePolylines () {
      const polylines = []
      this.polylines.forEach((item, index) => {
        const polyline = {
          material: this.polylineMaterial,
          positions: item.positions,
          width: this.polylineWidth,
          polylineIndex: index
        }
        polylines.push(polyline)
      })
      return polylines
    }
  },
  methods: {
    makeAppearance (val) {
      return new Cesium.PolylineMaterialAppearance({
        material: makeMaterial.call(this, val)
      })
    }
  }
}
